export default __webpack_public_path__ + "static/media/labs-icon.3da2da20.svg";